import { TextToImageConfigType } from "../../../models/text-to-image.ts";
import { TgTrainingVersion } from "../Models/store/tg-model-store.tsx";
import { TgIpType } from "../Projects/store/tg-projects-store.tsx";

export const canTgProjectGeneratePrefix = (ipType: TgIpType) => {
	// Generate Prefix using the generate prefix API only when IP type is Stylezed scene, defined character or object
	const generatePrefixActions = ["stylized_scene", "object_variants", "defined_character"];
	return generatePrefixActions.includes(ipType);
};

export const generateEvaluationConfigFile = (config: TextToImageConfigType) => {
	const configToExport = {
		model_details: {
			model_name: config.model_name,
			model_id: config.tailored_model_id,
			...(config.checkpoint_number && { checkpoint_step: parseInt(config.checkpoint_number) }),
		},
		generation_parameters: {
			...(config.prompt && { prompt: config.prompt }),
			...(config.tailored_model_influence && { model_influence: config.tailored_model_influence }),
			...(config.steps_num && { steps_num: config.steps_num }),
			...(config.aspect_ratio && { aspect_ratio: config.aspect_ratio }),
			...(config.fast !== undefined && { fast: config.fast }),
			...(config.seed && { seed: config.seed }),
			...(config.text_guidance_scale && { text_guidance_scale: config.text_guidance_scale }),
			...(config.negative_prompt && { negative_prompt: config.negative_prompt }),
			...(config.enhance_image !== undefined && { enhance_image: config.enhance_image }),
			...(config.guidance_method_1 && { guidance_method_1: config.guidance_method_1 }),
			...(config.guidance_method_1_scale && { guidance_method_1_scale: config.guidance_method_1_scale }),
			...(config.guidance_method_2 && { guidance_method_2: config.guidance_method_2 }),
			...(config.guidance_method_2_scale && { guidance_method_2_scale: config.guidance_method_2_scale }),
		},
	};

	return new File([JSON.stringify(configToExport, null, 2)], `tailored_generation_${config.tailored_model_id}.txt`, {
		type: "text/plain",
	});
};

/**
 * Builds a .json File containing only the structured prompt.
 */
export const generateStructuredPromptJsonFile = (structured_prompt: string, baseFileName: string): File => {
	let content: string;
	if (structured_prompt.trim().startsWith("{")) {
		try {
			const parsed = JSON.parse(structured_prompt) as object;
			content = JSON.stringify(parsed, null, 2);
		} catch {
			content = JSON.stringify({ structured_prompt }, null, 2);
		}
	} else {
		content = JSON.stringify({ structured_prompt }, null, 2);
	}
	const fileName = baseFileName.replace(/\.[^.]+$/, "") + ".json";
	return new File([content], fileName, { type: "application/json" });
};

export const isLightVersion = (trainingVersion?: TgTrainingVersion) => {
	return trainingVersion === "light" || trainingVersion === "bria-2.3";
};

export const isMaxVersion = (trainingVersion?: TgTrainingVersion) => {
	return trainingVersion === "max" || trainingVersion === "bria-3.2";
};

export const isLegacyTgRoute = (pathname?: string): boolean => {
	const p = pathname ?? window.location.pathname;
	return p.includes("/tailored-generation/projects/legacy");
};

export const isLegacyTgDemoRoute = (pathname?: string): boolean => {
	const p = pathname ?? window.location.pathname;
	return p.includes("/tailored-generation/demo/legacy/");
};
